export const watchlistServiceImplFactory = ({
  watchlistRepository,
}: {
  watchlistRepository: IWatchlistRepository;
}) => {
  const getWatchlist: IGetWatchlistService = async ({
    clinicId,
    floorIds,
    consentStatus,
  }) => {
    try {
      const response = await watchlistRepository.getWatchlist({
        clinic_id: clinicId,
        floor_ids: floorIds,
        consent_status: consentStatus,
      });

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const putWatchlist: IPutWatchlistService = async ({
    clinicId,
    watchlist,
  }) => {
    try {
      const response = await watchlistRepository.putWatchlist({
        clinic_id: clinicId,
        items: watchlist,
      });

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return { getWatchlist, putWatchlist };
};
